import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const PageContainer = styled.div`
  min-height: 100vh;
  background: #fff;
`;

export const MainSection = styled.section`
  padding: 120px 24px 80px;
  max-width: 1200px;
  margin: 0 auto;
  color: #1a1a1a;
`;

export const BackLink = styled(Link)`
  color: #01bf71;
  font-weight: 600;
  text-decoration: none;
  margin-bottom: 48px;
  display: inline-block;
  &:hover {
    text-decoration: underline;
  }
`;

// Intro section
export const IntroSection = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  align-items: center;
  margin-bottom: 80px;
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 32px;
    margin-bottom: 60px;
  }
`;

export const IntroPhotoWrap = styled.div`
  width: 100%;
  max-width: 420px;
  @media screen and (max-width: 768px) {
    max-width: 100%;
    margin: 0 auto;
  }
`;

export const IntroPhoto = styled.img`
  width: 100%;
  height: auto;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  object-fit: cover;
`;

export const IntroPhotoPlaceholder = styled.div`
  width: 100%;
  aspect-ratio: 4 / 5;
  background: linear-gradient(135deg, #e8e8e8 0%, #f0f0f0 100%);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #01bf71;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  padding: 24px;
`;

export const IntroContent = styled.div`
  max-width: 540px;
`;

export const PageHeading = styled.h1`
  font-size: 40px;
  line-height: 1.2;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 16px;
  @media screen and (max-width: 480px) {
    font-size: 28px;
  }
`;

export const IntroSubheading = styled.p`
  color: #01bf71;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 24px;
`;

export const PageSubtext = styled.p`
  font-size: 18px;
  line-height: 1.6;
  color: #333;
  margin-bottom: 0;
`;

// Section title
export const SectionTitle = styled.h2`
  font-size: 28px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 32px;
  @media screen and (max-width: 480px) {
    font-size: 22px;
  }
`;

// Brands section
export const BrandsSection = styled.section`
  margin-bottom: 80px;
  @media screen and (max-width: 768px) {
    margin-bottom: 60px;
  }
`;

export const BrandsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 32px;
`;

export const BrandLogoLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: opacity 0.2s, transform 0.2s;
  &:hover {
    opacity: 0.9;
    transform: scale(1.05);
  }
`;

/** Circular tile – logo width matches circle diameter (140px), content clipped to circle */
export const BrandLogoCircle = styled.div`
  width: 140px;
  height: 140px;
  min-width: 140px;
  min-height: 140px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
`;

/* Logo width = circle diameter (100% of 140px); height scales, clipped by circle */
export const BrandLogoImg = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  background: transparent;
`;

/** Text shown inside BrandLogoCircle when logo image is missing */
export const BrandLogoPlaceholder = styled.div`
  color: #01bf71;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  padding: 8px;
`;

// LinkedIn section
export const LinkedInSection = styled.section`
  margin-bottom: 80px;
  @media screen and (max-width: 768px) {
    margin-bottom: 60px;
  }
`;

export const LinkedInList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const LinkedInBtn = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 28px;
  background: #0a66c2;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  border-radius: 50px;
  transition: background 0.2s, transform 0.2s;
  &:hover {
    background: #004182;
    transform: translateY(-2px);
  }
`;

// Gallery section
export const GallerySection = styled.section`
  margin-bottom: 80px;
  @media screen and (max-width: 768px) {
    margin-bottom: 60px;
  }
`;

export const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
`;

export const GalleryItem = styled.div`
  width: 100%;
  aspect-ratio: 1;
  border-radius: 12px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.1);
`;

export const GalleryImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const GalleryPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #01bf71;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  padding: 24px;
`;
